import React from "react";
import PropTypes from "prop-types";
import EventEmitter from "../../services/event-emitter";

function onClickHandler(e, url, title) {
  e.preventDefault();
  const eventemitter = EventEmitter.getInstance();
  eventemitter.trigger("open-typeform-modal", [
    url,
    "knowledge-base-modal",
    { margin: "10px 0", height: "calc(100% - 20px)" }
  ]);
}

function KnowledgeBaseCard({ url = "", title = "", isMobile = false }) {
  const cardClass = isMobile
    ? "knowledge-base-card knowledge-base-card-mobile"
    : "knowledge-base-card";

  return (
    <a href="/#" onClick={e => onClickHandler(e, url, title)}>
      <div className={cardClass}>
        <h4 className="title">{title}</h4>
      </div>
    </a>
  );
}

KnowledgeBaseCard.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default KnowledgeBaseCard;



// WEBPACK FOOTER //
// ./src/components/knowledge-base/KnowledgeBaseCard.js